/**
 * Загрузчик веб-SDK Firebase. Пара к `firebaseWebSdk.ts` (нативная заглушка) —
 * почему раскол по файлам, а не ветка по `Platform.OS`, написано там.
 *
 * `import()` остаётся динамическим: webpack выносит firebase в отдельный чанк, и
 * первый экран веба не ждёт его загрузки.
 */
import type { FirebaseWebSdk } from './firebaseWebSdk';

export type { FirebaseWebSdk } from './firebaseWebSdk';

export async function loadFirebaseWebSdk(): Promise<FirebaseWebSdk | null> {
  const { initializeApp, getApps } = await import('firebase/app');
  const { getMessaging, getToken, isSupported, onMessage } = await import('firebase/messaging');
  return { initializeApp, getApps, getMessaging, getToken, isSupported, onMessage };
}
